var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issue-form-layout",attrs:{"id":"create-issue"}},[_c('edit-issue-form',{attrs:{"issueInfo":_vm.issueInfo,"submit":_vm.createIssue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }